export const setCurrentPage = '@history/setCurrentPage';
export const setItemsPerPage = '@history/setItemsPerPage';
export const setHistoryItems = '@history/setHistoryItems';
export const setHistoryShortList = '@history/setHistoryShortList';
export const setPaginationMeta = '@history/setPaginationMeta';
